import { PotentialAreasOfConcern as PotentialAreasOfConcernType } from "~/providers/utils/types/patientPreviewTypes";
import { PreviewSectionLayout } from "../../common/PreviewSectionLayout";
import { PotentialAreasConcernTitle } from "../PotentialAreasConcernV2/PotentialAreasConcernTitle";
import { PotentialAreasConcernTable } from "./PotentialAreasConcernTable";

interface PotentialAreasConcernProps {
  potentialAreasOfConcern?: PotentialAreasOfConcernType[];
}

export const PotentialAreasConcern = ({
  potentialAreasOfConcern,
}: PotentialAreasConcernProps) => (
  <PreviewSectionLayout title={<PotentialAreasConcernTitle />}>
    {!potentialAreasOfConcern?.length ? (
      <p>No flags detected</p>
    ) : (
      <PotentialAreasConcernTable
        potentialAreasOfConcern={potentialAreasOfConcern}
      />
    )}
  </PreviewSectionLayout>
);
